import * as React from "react";
import { classNameFromClasses } from "../css/cssHelpers";
import { IClassNameProps } from "../css/ICssClassProps";

export interface ICardImageProps extends IClassNameProps {
  position: "top" | "bottom";
}

export const CardImage: React.StatelessComponent<ICardImageProps> = ({
  position,
  children,
  className: cssClass,
  ...rest
}) => {
  const className = classNameFromClasses([`card-img-${position}`, cssClass]);
  return (
    <div {...className} {...rest}>
      {children}
    </div>
  );
};
